import { useState } from 'react';
import { Grid, GridItem, TextButton, Typography, useOverlayContext } from 'seagull';
import { useResponsive } from "../../contexts";
import styles from "./AgreementHeader.module.scss";
import cn from 'classnames';
import { useStore, useStoreActions } from "../../../store/store-context";
import { SwitchProposalBusiness } from "./SwitchProposalBusiness/SwitchProposalBusiness";
import { useSwitchBusiness } from "../../../hooks/useSwitchBusiness";
import { routes } from "../../../constants";
import { useOnMount } from "../../../hooks/useOnMount";
import { selectors } from "../../../store/state-selectors";
import { filterCustomerWorkspaces } from "./welcomeStepUtils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getFullName(name) {
  return !name.firstName ? null : !name.lastName ? name.firstName : name.firstName + ' ' + name.lastName;
}
export function AgreementHeader(_ref) {
  let {
    relationship,
    companyName,
    className,
    isPreview
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    logBI
  } = useStoreActions();
  const email = useStore(state => {
    var _state$userInfo;
    return (_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.email();
  });
  const workspaces = useStore(selectors.user.workspaces);
  const overlayContext = useOverlayContext();
  const [showSwitchProposalBusiness, setShowSwitchProposalBusiness] = useState(false);
  const {
    switchBusiness
  } = useSwitchBusiness();
  useOnMount(() => {
    if (!isPreview && !relationship.isSample && workspaces) {
      setShowSwitchProposalBusiness(filterCustomerWorkspaces(workspaces, relationship.vendor.id).length > 1);
    }
  });
  const onSwitchProposalBusiness = async () => {
    logBI(10834, {
      companyName,
      email
    });
    const newBusinessId = await overlayContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(SwitchProposalBusiness, {
          onClose: dismissModal,
          relationship: relationship
        });
      }
    });
    if (newBusinessId) {
      await switchBusiness(newBusinessId, {
        newRoute: routes.clientOnboarding(relationship.id)
      });
    }
  };
  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: 'small',
    className: className,
    children: [/*#__PURE__*/_jsx(GridItem, {
      span: 12,
      children: /*#__PURE__*/_jsx(Typography, {
        children: "Agreement between"
      })
    }), /*#__PURE__*/_jsxs(GridItem, {
      span: isMobile ? 12 : 6,
      className: cn(styles.side, {
        [styles.mobile]: isMobile
      }),
      children: [relationship.seller.firstName && /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        variant: "paragraph1",
        weight: "normal",
        "data-testid": "agreement-header-vendor-name",
        children: getFullName(relationship.seller)
      }), /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        variant: "paragraph1",
        "data-testid": "agreement-header-vendor-business",
        children: relationship.vendor.name
      }), /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        variant: "paragraph1",
        children: relationship.seller.email
      })]
    }), /*#__PURE__*/_jsxs(GridItem, {
      span: isMobile ? 12 : 6,
      className: cn(styles.side, {
        [styles.mobile]: isMobile
      }),
      children: [relationship.buyer.firstName && /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        variant: "paragraph1",
        weight: "normal",
        "data-testid": "agreement-header-client-name",
        children: getFullName(relationship.buyer)
      }), /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        variant: "paragraph1",
        "data-testid": "agreement-header-client-business",
        children: companyName
      }), /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        variant: "paragraph1",
        children: relationship.buyer.email
      }), showSwitchProposalBusiness && /*#__PURE__*/_jsx(TextButton, {
        "data-testid": "switch-proposal-business",
        onClick: onSwitchProposalBusiness,
        children: "Assign to a different business"
      })]
    })]
  });
}